export const PASSWORD_INPUT_PROPS = { autoComplete: 'new-password' };
